export default {
  customer_management: ['customer_management'],
  customer_add: ['customer_add'],
  customer_edit: ['customer_edit'],
  customer_status: ['customer_edit'],
  customer_detele: ['customer_detele']
}
